<script>
  import { onMount, onDestroy, getContext } from "svelte";
  import Radar from "./radar"
  import RadarMarker from "../components/RadarMarker.svelte"
  import { addOverlay, removeOverlay, getMap } from "../map";

  const flight = getContext("flight")
  const radar = flight.getHandler(Radar)

  let layer;
	onMount(() => {
		layer = L.layerGroup();
		addOverlay("Radar", layer, flight.overlay);
		layer.addTo(getMap())
	});
	onDestroy(() => {
		removeOverlay(layer, flight.overlay)
		layer.removeFrom(getMap())
	})
</script>

{#if $radar}
{#each Object.values($radar) as radarHit (radarHit[0].trackNumber)}
  <RadarMarker info={radarHit} {layer} />
{/each}
{/if}